class Home {
  constructor (opts = {}) {
    this.bindEvent();
    if (opts.ignoreAppendNewTag !== false) {
      this.appendNewTag();
    }
    $('.tabs>.tab:first-child').trigger('click');
  }

  bindEvent () {
    $('.tab').click((e) => {
      const $el = $(e.target);
      const index = $el.index();
      $el
        .addClass('active')
        .siblings('.tab')
        .removeClass('active');
      $el
        .parents('.card')
        .find('.tab-panel')
        .eq(index)
        .addClass('active')
        .siblings()
        .removeClass('active');
      const { today, total, path } = $el.data();
      $el
        .parents('.card')
        .find('[name=today]')
        .text(`${today || 0}条`);
      $el
        .parents('.card')
        .find('[name=total]')
        .text(`${total || 0}条`);
      // 有tab的模块，根据选中的tab标签来设置“更多”的跳转链接
      const $more = $el.parents('.card').find('.card__extra,.card__link');
      if (path && $more && $more.attr('href')) {
        // 若链接index.html结尾，则说明是静态之后的
        if ($more.attr('href').indexOf('.html') > -1) {
          $more.attr('href', $more.attr('href').replace(/^\/.*\.html/, path));
        } else {
          $more.attr('href', path);
        }
      }
    });
  }

  appendNewTag () {
    const $pubTime = this.$el.find('.pub-time');
    $pubTime.each((_, el) => {
      let timeString = $(el).data('value') + '';
      if (timeString) {
        timeString = timeString.replace('CST', 'GMT+0800');
      }
      // 当天发的公告打new标记
      if (new Date().toDateString() === new Date(timeString).toDateString()) {
        // 无标记时, 加上标记
        $(el).parent().has('.icon-newchunse')[0] ? 0 : $(el).before($('<i class="iconfont icon-newchunse"></i>'));
      }
    });
  }
}

module.exports = Home;
